module.exports = __webpack_public_path__ + "static/img/xiaomuzhineng.275a4f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiaomuzhineng.png
// module id = DvFP
// module chunks = 1